import { devMode } from "@utilities/helpers";
import appConfig from "../app.config.json";
export const settings = devMode
    ? { ...appConfig, targetRoute: "/" }
    : appConfig;
